import { JetView } from 'webix-jet';
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterSitebuilderView.
 * @extends JetView
 */
export default class FilterSitebuilderView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'UserId',
                            id: 'UserId',
                            css: 'my_input',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // User ID label
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder for User ID
                        },
                        {
                            view: 'text',
                            name: 'Name',
                            type: 'text',
                            css: 'prm-filterByUser',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Nombre del usuario'), // User Name label
                            labelPosition: 'top',
                            placeholder: _('Nombre'), // Placeholder for User Name
                        },
                        {
                            view: 'text',
                            name: 'Login',
                            type: 'text',
                            css: 'prm-filterByUser',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Login'), // Login label
                            labelPosition: 'top',
                            placeholder: _('Login'), // Placeholder for Login
                        },
                        {
                            view: 'text',
                            name: 'DateCreated',
                            id: 'DateCreated',
                            css: 'reportrange',
                            readonly: true, // Date field is read-only
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creacion'), // Date Created label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar'), // Placeholder for Date Created
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country selection label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for Country selection
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for country options
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'State',
                            label: _('Estado'), // State selection label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar'), // Placeholder for State selection
                            value: '2', // Default value for State
                            options: [
                                { id: '0', value: _('Todos') }, // All states option
                                { id: '1', value: _('Activo') }, // Active state option
                                { id: '2', value: _('Inactivo') }, // Inactive state option
                            ],
                        },
                        {},
                        {},
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Agregar Usuario'), // Add User button
                    css: 'prm-addVerifyAccount',
                    autowidth: true,
                    click: function () {
                        webix
                            .ui({
                                view: 'window',
                                id: 'addUserSitebuilder',
                                position: 'center',
                                fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
                                width: 500,
                                modal: true,
                                head: {
                                    view: 'toolbar',
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Agregar Usuario'), // Window title
                                            align: 'center',
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close',
                                            click: function () {
                                                this.getTopParentView().hide(); // Close window
                                            },
                                        },
                                    ],
                                },
                                body: {
                                    view: 'form',
                                    id: 'formAddUserSitebuilder',
                                    rows: [
                                        {
                                            view: 'combo',
                                            name: 'UserBackofficeId',
                                            id: 'UserBackofficeId',
                                            label: _('Usuario backoffice'), // Backoffice User label
                                            labelPosition: 'top',
                                            options: {
                                                keyPressTimeout: 1000,
                                                body: {
                                                    dataFeed: devConfig.geturlApi() + 'Admin/GetUsersSearch', // API endpoint for user search
                                                    ready: function () {},
                                                },
                                            },
                                            required: true, // Field is required
                                        },
                                        {
                                            view: 'text',
                                            name: 'Password',
                                            id: 'Password',
                                            type: 'password',
                                            css: 'my_input',
                                            label: "<span class='icon-drivers-license-o'></span>" + _('Contraseña'), // Password label
                                            labelPosition: 'top',
                                            required: true, // Field is required
                                            validate: function (value) {
                                                return (
                                                    value.length === 0 ||
                                                    (value.length >= 8 &&
                                                        /[a-z]/.test(value) &&
                                                        /[A-Z]/.test(value) &&
                                                        /[0-9]/.test(value)) // Password validation rules
                                                );
                                            },
                                            on: {
                                                onBlur: function () {
                                                    $$('NewPassword').validate(); // Validate New Password field on blur
                                                },
                                            },
                                        },
                                        {
                                            view: 'button',
                                            value: _('Guardar'), // Save button
                                            type: 'form',
                                            click: function () {
                                                const newdata = $$('formAddUserSitebuilder').getValues(); // Get form values
                                                if (
                                                    $$('formAddUserSitebuilder').validate() // Validate form
                                                ) {
                                                    if (newdata.NewPassword === '') {
                                                        delete newdata.NewPassword; // Remove NewPassword if empty
                                                    }
                                                    var vthis = this;
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type for AJAX request
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'UserManagement/AddUserSitebuilder', // API endpoint for adding user
                                                            newdata,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    $$('addUserSitebuilder').hide(); // Hide window on error
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var data = JSON.parse(text); // Parse response data
                                                                    if (!data.HasError) {
                                                                        webix.message(
                                                                            '¡Usuario creado!', // Success message
                                                                        );
                                                                    } else {
                                                                        webix.message({
                                                                            title: '¡Error!',
                                                                            type: 'alert-error',
                                                                            text: _(
                                                                                'ERROR' + data.CodeError.toString(), // Error message
                                                                            ),
                                                                        });
                                                                    }
                                                                    $$('addUserSitebuilder').hide(); // Hide window after operation
                                                                },
                                                            },
                                                        );
                                                }
                                            },
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate(); // Validate form on change
                                            },
                                        },
                                    },
                                },
                            })
                            .show(); // Show the user addition window
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form fields
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter', // Enter key to trigger
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter values
                        this.app.callEvent('requests:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section with filters and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form',
            type: 'clean',
            id: 'formFilter',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion on larger screens
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('DateCreated').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
